export default __webpack_public_path__ + "static/1250-7d8c482b3c70638d5e582f2cf4302835.gif";